export default function simpleAlert({ title, body }: { title?: string; body?: Node }) {
  const content = up.element.createFromHTML(`
    <div up-main>
      <h5 title class="simple-alert--title"></h5>
      <div body class="simple-alert--text"></div>
      <div class="d-flex">
        <button up-dismiss class="btn btn-primary simple-alert--button">Ok</button>
      </div>
    </div>
  `)
  const titleTag = content.querySelector('[title]')!
  if (title) {
    titleTag.textContent = title
  } else {
    titleTag.remove()
  }

  if (body) {
    content.querySelector('[body]')!.appendChild(body)
  }

  void up.layer.open({
    document: content,
    mode: 'modal',
    class: 'simple-alert',
  })
}
